module.exports = __webpack_public_path__ + "static/media/open-book-icon.2c9cead6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/open-book-icon.png
// module id = 32
// module chunks = 0